// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c6994f0f","703":"4a01edae","787":"d4aba7ab","885":"50c01123"}[chunkId] + ".chunk.js";
};